<script>
import DatePicker from "@/components/pickers/DatePicker.vue";
import TimePicker from "@/components/pickers/TimePicker.vue";
import { VInput } from "vuetify/components";

export default {
  name: "DateTimePicker",
  components: { TimePicker, DatePicker },
  extends: VInput,
  props: {
    modelValue: String,
    dateLabel: String,
    timeLabel: String,
    min: String,
    required: Boolean,
    dateClass: String,
    timeClass: String,
    hideDetails: {
      type: Boolean,
      default: true,
    },
  },
  emits: ["update:modelValue"],
  data() {
    return {
      date: null,
      time: null,
    };
  },
  computed: {
    fullDate() {
      return this.modelValue ? this.$dayjs(this.modelValue).format("MM/DD/YYYY HH:mm") : null;
    },
  },
  watch: {
    modelValue: {
      handler(value) {
        this.setDateTime(value);
      },
      immediate: true,
    },
  },
  methods: {
    setDateTime(value) {
      if (value) {
        const date = this.$dayjs(value);
        this.date = date.format("YYYY-MM-DD");
        this.time = date.format("HH:mm");
      } else {
        this.date = null;
        this.time = null;
      }
    },
    onUpdateDate(date) {
      this.emitValue(date, this.time);
    },
    onUpdateTime(time) {
      this.emitValue(this.date, time);
    },
    emitValue(date, time) {
      if (!date || !time) {
        return this.$emit("update:modelValue", null);
      }
      const result = [date, time].join("T");
      this.$emit("update:modelValue", result);
    },
    minDateValidator(value) {
      if (!this.min || !value) return true;
      return (
        this.$dayjs(value).isAfter(this.$dayjs(this.min)) ||
        "Date can not be before " + this.$dayjs(this.min).format("MM/DD/YYYY HH:mm")
      );
    },
  },
};
</script>

<template>
  <v-row :class="dateClass">
    <v-col>
      <date-picker
        v-model="date"
        :label="dateLabel || 'Date'"
        :min="min"
        :required="required"
        skip-validation
        @update:model-value="onUpdateDate"
      ></date-picker>
    </v-col>
    <v-col>
      <time-picker
        v-model="time"
        :disabled="!date"
        :label="timeLabel || 'Time'"
        :required="required"
        @update:model-value="onUpdateTime"
      ></time-picker>
    </v-col>
  </v-row>
  <v-row :class="timeClass">
    <v-col class="pt-0">
      <v-text-field
        :hide-details="hideDetails"
        :model-value="fullDate"
        :rules="[minDateValidator]"
        type="hidden"
        variant="plain"
      ></v-text-field>
    </v-col>
  </v-row>
</template>

<style lang="scss" scoped></style>
